import { useCallback } from 'react';

import { NewsCard } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCard';
import { NewsCardPinned } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCardPinned';
import { useNavigateToNewsDetail } from 'hb-react/frontoffice/apps/NewsIndex/hooks/useNavigateToNewsDetail';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';
import { makeNewsItemBackwardCompatible } from 'hb-react/shared/utils/news/newsItem';

import {
  type MakeItemRendererArgs,
  type NewsItem,
  type NewsItemOld,
} from './types';

export const makeItemRenderer =
  ({ fallbackCoverPicture, pinned }: MakeItemRendererArgs) =>
  ({ item }: { item: NewsItem | NewsItemOld }) => {
    const {
      content,
      feedableAt,
      id,
      newCoverPicture,
      publishedAt,
      seoDescription,
      seoTitle,
      subject,
    } = makeNewsItemBackwardCompatible(item);

    const { onClick } = useNavigateToNewsDetail();
    const handleClick = useCallback(() => onClick(id), [onClick, id]);

    const date = feedableAt
      ? dayjs(feedableAt).format('LL')
      : dayjs(publishedAt).format('LL');

    return pinned ? (
      <NewsCardPinned
        coverPicture={newCoverPicture.previewUrl || ''}
        fallbackCoverPicture={fallbackCoverPicture}
        key={id}
        onClick={handleClick}
        subject={seoTitle || subject}
      />
    ) : (
      <NewsCard
        coverPicture={newCoverPicture.previewUrl || ''}
        description={seoDescription || content}
        fallbackCoverPicture={fallbackCoverPicture}
        key={id}
        onClick={handleClick}
        publishedAt={date}
        subject={seoTitle || subject}
      />
    );
  };
